import { get, patch } from "@insite/client-framework/Services/ApiService";
import {
    BaseModel,
    GetOrdersListApiParameter,
    // GetTrackOrdersListApiParameter,
    OrderCollectionModel,
    PaginationModel,
} from "@insite/client-framework/Types/ApiModels";

export interface OrdersListModel extends BaseModel {
    ordersList: OrderCollectionModel;
}

export interface OrdersSearchFilter {
    orderNumber?: string | null;
    PoNumber?: string | null;
    search?: string | null;
    status: string[];
    customerSequence?: string | null;
    FromDate?: string | null;
    ToDate?: string | null;
    orderTotalOperator?: string | null;
    OrderTotal?: number | null;
    productErpNumber?: number | null;
    currentPage?: number | null;
    Page?: number | null;
    PageSize?: number | null;
    sort?: string | null;
    isSearchActive?: boolean;
}

export interface AdiGlobalOrdersSearchFilter {
    refrencenumber?: string;
    orderType?: string;
    selectedpage?: number;
    customerSequence?: string;
    sort?: string;
    dateType?: string;
    toDate?: string;
    fromDate?: string;
    ponumber?: string;
    ordernumber?: string;
    ordertotaloperator?: string;
    ordertotal?: string;
    status?: string;
    statusDesc?: string;
    ordersearchtype?: string;
    isSearch?: boolean;
    dateRange?: string;
    dateRangeDesc?: string;
    isSearchResult?: boolean;
    isChangeCustomer?: boolean;
    pageSize?: number;
    page?: number;
    currentPage?: number;
    properties?: "{'status':'All'}", // ---P21 Change
    isSearchActive?: boolean;
}

export async function getOrdersList(parameter: GetOrdersListApiParameter) {
    var ordersListUrl = "/api/v1/orders";

    if (!parameter.filter) {
        return;
    }
 
    //------- NA Spire code
    // let filterParameter: OrdersSearchFilter = {
    //     orderNumber: null,
    //     PoNumber: null,
    //     search: null,
    //     status: [],
    //     customerSequence: parameter.filter.customerSequence,
    //     FromDate: parameter.filter.fromDate,
    //     ToDate: parameter.filter.toDate,
    //     orderTotalOperator: null,
    //     OrderTotal: 0,
    //     productErpNumber: null,
    //     currentPage: null,
    //     Page: null,
    //     PageSize: null,
    //     sort: parameter.filter.sort,
    //     isSearchActive: parameter.filter.isSearchActive,
    // };

    // filterParameter.status.push("OPEN");

    // if (parameter.filter.poNumber != "") {
    //     filterParameter.PoNumber = parameter.filter.poNumber;
    // }
    // if (parameter.filter && parameter.filter.pageSize) {
    //     filterParameter.PageSize = parameter.filter.pageSize;
    // }
    // if (parameter.filter && parameter.filter.currentPage) {
    //     filterParameter.currentPage = parameter.filter.currentPage;
    // }
    // if (parameter.filter && parameter.filter.page) {
    //     filterParameter.Page = parameter.filter.page;
    // }
    // if (parameter.filter && parameter.filter.isSearchActive) {
    //     filterParameter.isSearchActive = parameter.filter.isSearchActive;
    // }
   
    //added new logic --- P21 Change
    let currentObj = parameter.filter;
    if (parameter.filter.statusDesc == "ALL" && parameter.filter.ponumber == "") {
        
        const {ponumber,status,properties, ...updatedObj} = currentObj;
         currentObj = updatedObj;
    }

    else if (parameter.filter.statusDesc == "ALL" && parameter.filter.ponumber != "")
    {
        const {status,properties, ...updatedObj} = currentObj;
        currentObj = updatedObj;
    }

    else if (parameter.filter.statusDesc != "ALL" && parameter.filter.ponumber == "")
    {
        const {ponumber, ...updatedObj} = currentObj;
        currentObj = updatedObj;
    }
    const result = await get<OrderCollectionModel>(ordersListUrl, currentObj as any);
    return result;
}

// export async function getOrderDetails(parameter: any) {
//     var ordersListUrl = "/api/v1/GetOrderDetails/?";

//     if (!parameter) {
//         return;
//     }

//     let filterParameter: any = {
//         OrderNumber: null,
//         status: []
//     };

//     filterParameter.status.push("OPEN");

//     if (parameter.OrderNumber != "") {
//         filterParameter.OrderNumber = parameter.OrderNumber;
//     }
//     const result = await get<any>(ordersListUrl, parameter as any);
//     return result;
// }


